import React from "react";
import { Award, Sparkles, Heart } from "lucide-react";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f3f9] to-[#e8e4f3]">
      <section className="relative bg-gradient-to-br from-[#0f0f2e] via-[#1a1a3e] to-[#2a1a4e] text-white py-20">
        <div className="max-w-4xl px-4 mx-auto text-center sm:px-6 lg:px-8">
          <h1 className="mb-6 font-serif text-5xl">About Maison de Bijoux</h1>
          <p className="text-xl text-gray-300">
            Where elegance meets individuality
          </p>
          <p className="text-xl text-gray-300">
            Made with heart, meant to shine on you{" "}
          </p>
        </div>
      </section>

      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 mb-20 md:grid-cols-2">
          <div>
            <h2 className="mb-6 font-serif text-4xl text-gray-900">
              Our Story
            </h2>
            <p className="mb-4 leading-relaxed text-gray-700">
              Born from a passion for artistry and a love for detail, Maison de
              Bijoux was founded to celebrate the beauty of self-expression
              through jewelry. Every piece is thoughtfully designed to capture
              emotion — combining contemporary sophistication with timeless
              charm.
            </p>
            <p className="mb-4 leading-relaxed text-gray-700">
              From our Shop, we bring together craftsmanship, quality, and
              meaning — creating jewelry that tells your story and becomes part
              of your moments.
            </p>
            <p className="leading-relaxed text-gray-700">
              Because for us, it’s not just about wearing jewelry; it’s about
              feeling beautiful in your own light.
            </p>
          </div>
          <div className="bg-gradient-to-br from-gray-200 to-[#e8e4f3] rounded-3xl h-96"></div>
        </div>

        <div className="grid gap-8 mb-20 md:grid-cols-3">
          <div className="p-8 text-center bg-white shadow-lg rounded-2xl">
            <div className="w-16 h-16 bg-[#e8e4f3] rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="w-8 h-8 text-[#d4af37]" />
            </div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Master Craftsmanship
            </h3>
            <p className="text-gray-600">
              Each piece is meticulously handcrafted by skilled artisans with
              decades of experience.
            </p>
          </div>
          <div className="p-8 text-center bg-white shadow-lg rounded-2xl">
            <div className="w-16 h-16 bg-[#e8e4f3] rounded-full flex items-center justify-center mx-auto mb-4">
              <Sparkles className="w-8 h-8 text-[#d4af37]" />
            </div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Finest Materials
            </h3>
            <p className="text-gray-600">
              We use only the highest quality ethically sourced gemstones and
              precious metals.
            </p>
          </div>
          <div className="p-8 text-center bg-white shadow-lg rounded-2xl">
            <div className="w-16 h-16 bg-[#e8e4f3] rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="w-8 h-8 text-[#d4af37]" />
            </div>
            <h3 className="mb-3 text-xl font-semibold text-gray-900">
              Timeless Design
            </h3>
            <p className="text-gray-600">
              Our designs blend classic elegance with contemporary style for
              pieces that last forever.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
